import request from '../utils/request'
import { encryptDes } from '../des/des'
/**
 * 文件上传
 * @param {File} file - 文件

 *
 * @returns {JSON} - 状态 {}
 */

export const fileUpload = (formData) =>
  request.post('/AppHandler/App.ashx?action=activeequips', formData, {
    'Content-Type': 'multipart/form-data',
  })

/**
 * 注册方法
 * @param {string} unm - 用户名
 * @param {string} pwd - 密码
 * @param {string} phone - 手机号
 * @param {string} valcode - 验证码
 *
 * @returns {JSON} - 注册状态 {}
 */

export const register = (unm, pwd, phone, valcode) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'register',
      unm: unm,
      pwd: pwd,
      phone: phone,
      valcode: valcode,
    },
  })

/**
 * 用户登录
 * @param {string} unm - 用户名
 * @param {string} pwd - 密码
 * @param {string} pwdDes - 加密密码
 * @returns {JSON} - 用户信息 {ResultType,Message,LogMessage,AppendData}
 */

export const login = (unm, pwd, localtoken = '') => {
  let despwd = encryptDes(pwd, 'haiyan2020', 'haiyan2020')
  return request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'login',
      unm: unm,
      pwd: despwd,
      localtoken: localtoken,
    },
  })
}

/**
 * 修改密码
 * @param {string} unm - 用户名
 * @param {string} pwd - 密码
 * @param {string} newpwd - 密码
 * @returns {JSON} - 用户信息 {ResultType,Message,LogMessage,AppendData}
 */

export const changepwd = (unm, pwd, newpwd) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'changepwd',
      unm: unm,
      pwd: pwd,
      newpwd: newpwd,
    },
  })

/**
 * 获取我的设备列表
 *
 * @returns {Array} - 设备信息 {}
 */

export const myequips = () =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'myequips',
    },
  })

/**
 * 设备详细
 * @param {string} equipid - 设备id
 * @returns {Array} - 设备信息 {}
 */

export const equipinfo = (equipid) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'equipinfo',
      equipid: equipid,
    },
  })
/**
 * save设备详细
 * @param {string} equip - 设备
 * @returns {Array} - 设备信息 {}
 */

export const saveequipinfo = (equip, equipid) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'saveequipinfo',
      equipid: equipid,
      nodataflag: equip.nodataflag,
      overflag: equip.overflag,
      dataspan: equip.dataspan,
      standardjd: equip.standardjd,
      standardwd: equip.standardwd,
      offsize: equip.offsize,
      etime: equip.etime,
      noalertspan: equip.noalertspan,
      lastupdatetime: equip.lastupdatetime,
      waterflag: equip.waterflag,
    },
  })

/**
 * getEquipNotice
 *
 * @param {string} equip - 设备
 * @param {string} isdelete - 是否已读
 * @returns {Array} - 设备信息 {}
 */

export const getEquipNotice = (equipid, startTime, endTime) =>
  // request('http://106.12.13.113:8633/AppHandler/App.ashx?action=getfirelist', {
  //   baseURL: '',
  //   method: 'Get',
  //   params: {
  //     // isdelete: 0,
  //     starttime: startTime,
  //     endtime: endTime,
  //     eid: equipid
  //   }
  // })
  request('/AppHandler/App.ashx?action=getfirelist', {
    method: 'Get',
    params: {
      // isdelete: 0,
      starttime: startTime,
      endtime: endTime,
      eid: equipid,
    },
  })

/**
 * updateEquipNotice
 * @param {string} equip - 设备
 * @returns {Array} - 设备信息 {}
 */

export const updateEquipNotice = (equipid) =>
  // request('http://106.12.13.113:8633/AppHandler/App.ashx?action=updatestate', {
  //   baseURL: '',
  //   method: 'Get',
  //   params: {
  //     // IsDelete: 1
  //     ids: equipid
  //   }
  // })
  request('/AppHandler/App.ashx?action=updatestate', {
    method: 'Get',
    params: {
      // IsDelete: 1
      ids: equipid,
    },
  })

/**
 * getsystime
 */

export const getsystime = () =>
  // request('http://106.12.13.113:8633/AppHandler/App.ashx?action=systime', {
  //   baseURL: '',
  //   method: 'Get',
  //   params: {}
  // })
  request('/AppHandler/App.ashx?action=systime', {
    method: 'Get',
    params: {},
  })

/**
 * 获取共享设备列表
 *
 * @returns {Array} - 设备信息 {}
 */

export const sharedequips = () =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'sharedequips',
    },
  })

/**
 * 获取手机验证码
 * @param {string} phone - 手机号
 * @returns {Array} - 设备信息 {}
 */

export const sendcode = (phone) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'sendcode',
      phone: phone,
    },
  })

/**
 * 激活设备
 * @param {string} equipno - 设备编码
 * @param {string} cdkey - 密钥码
 * @returns {Array} - 设备信息 {}
 */

export const activeequip = (equipno, cdkey) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'activeequip',
      equipno: equipno,
      cdkey: cdkey,
    },
  })

/**
 * 历史轨迹
 * @param {string} bdt - 开始时间
 * @param {string} edt - 结束时间
 * @param {string} equipid - 设备id
 * @returns {Array} - 设备信息 {}
 */

export const equiphistory = (bdt, edt, equipid, pindex = 1, pagesize = 40) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'equiphistory',
      bdt: bdt,
      edt: edt,
      equipid: equipid,
      pindex: pindex,
      pnum: pagesize,
    },
  })
/**
 * 首页所有点
 * @param {string} datepoint - 时间点
 * @returns {Array} - 设备信息 {}
 */

export const myequippoint = (datepoint = '') =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'myequippoint',
      datepoint: datepoint,
    },
  })
/**
 * 分享设备
 * @param {string} equipno - 设备编码
 * @param {string} usernm - 用户名
 * @param {string} phone - 电话号码
 * @returns {JSON} - 设备信息 {}
 */

export const sharedequip = (equipid, usernm, phone) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'sharedequip',
      equipid: equipid,
      usernm: usernm,
      phone: phone,
    },
  })

/**
 * 分享设备
 * @param {string} equipid   - 设备id
 * @param {string} userid - 用户id
 * @returns {JSON} - 设备信息 {}
 */

export const cancelshard = (equipid, userid) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'cancelshard',
      equipid: equipid,
      userid: userid,
    },
  })

/**
 * mock数据
 * @returns {JSON} - 设备信息 {}
 */

export const reportGroup = () =>
  request.get('/AppHandler/App.ashx', {
    // request.get('/mock/reportGroup', {
    // baseURL: '/'
    params: {
      action: 'eqtypeinfo',
    },
  })
/**
 * mock数据
 * @returns {JSON} - 设备信息 {}
 */

export const report = (bdt, edt, equipid, deviceParamId) =>
  request.get('/AppHandler/App.ashx', {
    params: {
      action: 'eqtypechart',
      bdt,
      edt,
      equipid,
      deviceParamId,
    },
  })

/**
 * 大浮标看板
 * @param {string} equipid   - 设备id
 * @param {string} number - 数据长度(可选)
 * @param {string} bdt - 开始时间(可选)
 * @param {string} edt  - 结束时间(可选)
 * @returns {JSON} - 设备信息 {}
 */

export const bigfloater = (equipid, number, bdt, edt) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'bigfloater',
      equipid: equipid,
      number: number,
      bdt: bdt,
      edt: edt,
    },
  })

export const bigfloater_test = (equipid, number, bdt, edt) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'bigfloater',
      equipid: equipid,
      number: number,
      bdt: bdt,
      edt: edt,
    },
  })
export const bigfloater2 = (equipid, number, bdt, edt) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'bigfloater2',
      equipid: equipid,
      number: number,
      bdt: bdt,
      edt: edt,
    },
  })
  export const bigfloater3 = (equipid, number, bdt, edt, adcpType) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'bigfloater3',
      equipid,
      number,
      bdt,
      edt,
      adcpType
    },
  })
/**
 * 大浮标看板信息
 * @param {string} equipid   - 设备id
 * @returns {JSON} - 设备信息 {}
 */

export const bigfloaterkb = (equipid, number, bdt, edt) =>
  request('/AppHandler/App.ashx', {
    method: 'POST',
    params: {
      action: 'bigfloater',
      equipid: equipid,
      number: number,
      bdt: bdt,
      edt: edt,
    },
  })
// 波谱图数据
export function getBopuList(params) {
  return request({
    url: 'http://118.190.201.141:8001/AppHandler/App.ashx',
    method: 'get',
    params: params,
  })
}
// 波谱图数据通过解析方式
export function getnewBopuList(params) {
  return request({
    url: 'http://118.190.201.141:8001/spectrogram1',
    method: 'get',
    params: params,
  })
}
// //
// export function getloginBopu( params ) {
//   return request({
//     url: `http://150.139.215.67:15001/Bopu/detail`,
//     method: 'get',
//     params: params,
//   })
// }
